import React, { useEffect, useState } from "react";
import Responseloader from "./ResponseLoader";
import { GetIp } from "./Get_ip";
import "./myReactSelect.css";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import "./paymentPrint.css";
import "./baseForms.css";
import axios from "axios";
import { baseurl } from "../../../baseurl";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

export default function PartyOverview(props) {
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [noOfRows, setNoOfRows] = useState([]);
  const [nextPrintPage, setNextPrintPage] = useState(false);
  const [goBackUrl, setGoBackUrl] = useState([]);
  const [invoiceLines, setInvoiceLines] = useState([]);

  useEffect(() => {
    console.log("ffff", props, props.location.state?.id);
    const id = props.location.state?.id;
    // const id = 11;
    const url = props.location.state?.url;
    setGoBackUrl(url);
    if (id) {
      getDataWithId(id);
    }
  }, []);
  const dynamicTopDesc = () => {
    return (
      <Row className="my-1 mt-1 page-header">
        <Container>
          <Row>
            <Col md="12" className="text-center mb-3">
              <h4 style={{ fontWeight: "bold" }}>CUSTOMER RECEIPTS</h4>
            </Col>
            <Col md="6">
              <h5>
                Voucher No: <span className="text-muted">{printData[0]?.voucherNo}</span>
              </h5>
            </Col>
            <Col md="6">
              <h5 style={{ textAlign: "right" }}>
                Pay Date: <span className="text-muted">{printData[0]?.date}</span>
              </h5>
            </Col>
            <Col md="6">
              <h5>
                Customer: <span className="text-muted">{printData[0]?.customerName}</span>
              </h5>
            </Col>
            <Col md="6">
              <h5 style={{ textAlign: "right" }}>
                Bank/Cash: <span className="text-muted">{printData[0]?.BANK_NAME}</span>
              </h5>
            </Col>
          </Row>
        </Container>
      </Row>
    );
  };
  const getDataWithId = (id) => {
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/moneyIn/getSomOnePaidMeData`,
        {
          receiptMtId: id,

          username: username,
          companyId: companyId,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data;
        getFooterDataWithId(response[0]?.inv_book_id);
        console.log("hhhhhqq", response);

        // A receipt with nothing applied comes back as one row with null
        // invoice columns (LEFT JOIN), so paid_amt must be null-safe. The old
        // `|| unapplied_amount` fallback also fired when the result was 0
        // (fully applied) and showed the first row's figure instead.
        const masterAmount = Number(response[0]?.masterAmount) || 0;
        const sumOfPaidAmount = response.reduce(
          (total, item) => total + (Number(item.paid_amt) || 0),
          0
        );
        const unAppliedAmount = masterAmount - sumOfPaidAmount;

        console.log(
          "summmm",
          unAppliedAmount,
          response[0]?.masterAmount,
          sumOfPaidAmount
        );

        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValues = [];
        for (let i = 0; i < response.length; i++) {
          formValues.push({
            inv_book_desc: response[i].inv_book_desc,
            customerName: response[i].customerName,
            BANK_NAME: response[i].BANK_NAME,
            docNo: response[i].docNo,
            voucherNo: response[i].RECEIPT_NO,
            date: response[i].DATE,
            invoiceDate: response[i].invoiceDate,
            invBookDesc: response[i].INV_BOOK_DESC,
            paid_amount: response[i].paid_amt,
            masterAmount: masterAmount,
            appliedAmount: sumOfPaidAmount,
            unAppliedAmount: unAppliedAmount >= 0 ? unAppliedAmount : 0,
            purch_date: response[i].purch_date,
            wh_tax_amt: response[i].wh_tax_amt,
            wh_tax_perc: response[i].wh_tax_perc,
          });
        }
        // for (let i = 0; i < 30; i++) {
        //   formValues.push({
        //     inv_book_desc: "Hello",
        //     customerName: "Hello",
        //     BANK_NAME: "Hello",
        //     docNo: i + 1,
        //     date: "Hello",
        //     invBookDesc: "Hello",
        //     paid_amount: "Hello",
        //     unAppliedAmount: "Hello",
        //     purch_date: "Hello",
        //   });
        // }
        console.log("hhhhhqq", formValues);
        // printData keeps every row for the header/summary; the grid only gets
        // real invoice lines. The grid shows 2 invoices per row, so rows =
        // ceil(n / 2) — it was n / 3, which silently dropped invoices.
        const lines = formValues.filter((r) => r.docNo != null);
        let rowArray = [];
        const numberOfRows = Math.ceil(lines.length / 2);
        for (let index = 0; index < numberOfRows; index++) {
          rowArray.push(index);
        }
        if (lines.length > 18) {
          setNextPrintPage(true);
        }
        setNoOfRows(rowArray);
        setInvoiceLines(lines);
        setPrintData(formValues);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponse(false);
      });
  };
  const getFooterDataWithId = (id) => {
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/masterData/getDocFooterSetupId`,
        { id: 1, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data[0];
        console.log("hhhhh", response);
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValues = [];

        if (response.desc1 !== " ") {
          formValues.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== " ") {
          formValues.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== " ") {
          formValues.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== " ") {
          formValues.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== " ") {
          formValues.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== " ") {
          formValues.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        console.log("hhhhh>", formValues);
        setFooterData(formValues);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponse(false);
      });
  };

  // Summary cells: show 0 as "0" rather than blank; blank only when missing.
  const fmtAmt = (v) =>
    v === null || v === undefined || v === ""
      ? ""
      : new Intl.NumberFormat("en-US").format(Number(v) || 0);

  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  return (
    <>
      {loadingResponse ? (
        <Responseloader />
      ) : (
        <div id="pdfContent page-container">
          <Row className="app-body-Invoice bg-white rounded-lg ">
            <Col xs="12" className="mb-5">
              <div id="pdfContent">
                <br></br>
                <br></br>
                <Container>
                  <Row className=" ">
                    <Col md="6">
                      <h3>{localStorage.getItem("companyName")}</h3>
                    </Col>

                    <Col md="6">
                      <div style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary mx-2 btn-sm print-half-size"
                          id="printPageButton"
                          onClick={() => {
                            window.print();
                          }}
                        >
                          Print to PDF!
                        </button>
                        {/* `pathname: { goBackUrl }` used to pass an object, which
                            matched no route and dropped the user on login. Step back
                            in history so the previous screen keeps its state; fall
                            back to the caller's url when opened directly. */}
                        <button
                          className="btn btn-primary m-1  btn-sm"
                          id="printPageButton"
                          onClick={() => {
                            if (props.history.length > 1) {
                              props.history.goBack();
                            } else {
                              props.history.push(goBackUrl || "/OverviewSomeOnePaid");
                            }
                          }}
                        >
                          Back
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Container>

                {dynamicTopDesc()}
                <Container>
                  <table className="my-doubleTable">
                    <thead>
                      <tr>
                        {[0, 1].map((colIndex) => (
                          <React.Fragment key={colIndex}>
                            <th
                              colSpan="2"
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              Invoice
                            </th>
                            <th
                              colSpan="1"
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              Receipt
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                      <tr>
                        {[0, 1].map((colIndex) => (
                          <React.Fragment key={colIndex}>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "80px",
                                backgroundColor: "white",
                                textAlign: "center",
                              }}
                            >
                              No
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                backgroundColor: "white",
                                textAlign: "center",
                              }}
                            >
                              Date
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {noOfRows.length === 0 && (
                        <tr>
                          <td
                            colSpan="6"
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              padding: "8px",
                            }}
                          >
                            No invoices applied against this receipt
                          </td>
                        </tr>
                      )}
                      {noOfRows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {[0, 1].map((colIndex) => {
                            const dataIndex = rowIndex * 2 + colIndex;
                            const currentRow = invoiceLines[dataIndex];

                            return (
                              <React.Fragment key={colIndex}>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    textAlign: "center",
                                  }}
                                >
                                  {currentRow?.docNo}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    textAlign: "center",
                                  }}
                                >
                                  {currentRow?.invoiceDate}
                                </td>
                                <td
                                  style={{
                                    textAlign: "right",
                                    border: "1px solid black",
                                    paddingRight: "8px",
                                  }}
                                >
                                  {currentRow?.paid_amount
                                    ? new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "PKR",
                                      }).format(currentRow?.paid_amount)
                                    : null}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Summary Table */}
                  <table
                    className="summary-table"
                    style={{
                      marginTop: "2rem",
                      width: "35%",
                      marginLeft: "auto",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Total Receipt
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "right",
                          }}
                        >
                          {fmtAmt(printData[0]?.masterAmount)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Unapplied Amt
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "right",
                          }}
                        >
                          {fmtAmt(printData[0]?.unAppliedAmount)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Applied Amt
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "right",
                          }}
                        >
                          {fmtAmt(printData[0]?.appliedAmount)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          WH Tax %
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "right",
                          }}
                        >
                          {printData[0]?.wh_tax_perc || ""}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          WH Tax Amt
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "right",
                          }}
                        >
                          {fmtAmt(printData[0]?.wh_tax_amt)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                          }}
                        >
                          Net Receipt
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "right",
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                          }}
                        >
                          {printData.length
                            ? fmtAmt(
                                (Number(printData[0]?.masterAmount) || 0) -
                                  (Number(printData[0]?.wh_tax_amt) || 0)
                              )
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Container>

                <Container
                  className={`${nextPrintPage ? "footerNewPage" : "footer"}`}
                >
                  <Row
                    className=""
                    style={{ textAlign: "center", marginTop: "5rem" }}
                  >
                    {footerData.map((row, index) => (
                      <Col
                        key={index}
                        lg="4"
                        md="4"
                        sm="4"
                        className="px-5"
                        style={{
                          marginBottom: "3rem",
                          marginTop: row.enteredBy != 1 ? "0" : "0",
                        }}
                      >
                        <h5> {row.enteredBy ? printData[0]?.name : "  "}</h5>
                        <hr
                          style={{
                            border: "1px solid ",
                            borderColor: "E4E5E6",
                            margin: "revert",
                          }}
                        />
                        <h4>{row.desc}</h4>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
